import {View, Dimensions} from 'react-native';
import RoundedAppButton, {
  RoundedAppButtonType,
} from 'src/components/elements/RoundedAppButton';
import GrpReferralRedesign from 'src/components/img/svg/GrpReferralredesign';
import Styles from 'src/components/Styles';
import Localized from 'src/constants/AppStrings';

const screenWidth = Dimensions.get('screen').width;

export function getReferralStyles(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    referralTitle: {
      marginTop: Styles.Spacing.m2,
      fontSize: Styles.Fonts.f3,
      fontWeight: 'bold',
      textAlign: 'center',
      fontFamily: Styles.FontFamily.robotoRegular,
      color: Styles.Colors.Canteen.darkGreen,
    },
    referralDesc: {
      marginTop: Styles.Spacing.m2 + Styles.Spacing.m1,
      fontSize: Styles.Fonts.f1,
      fontWeight: '400',
      textAlign: 'center',
      fontFamily: Styles.FontFamily.robotoRegular,
      color: Styles.tabBarTextColor,
    },
    referralExpiry: {
      marginTop: Styles.Spacing.m3,
      fontSize: Styles.Fonts.f1,
      fontWeight: '400',
      textAlign: 'center',
      fontFamily: Styles.FontFamily.robotoRegular,
      color: Styles.Colors.Canteen.darkGreen,
      fontStyle: 'italic',
    },
    totalReferralsKey: {
      fontSize: Styles.Fonts.f8,
      fontWeight: '400',
      textAlign: 'center',
      fontFamily: Styles.FontFamily.robotoRegular,
      color: Styles.lightGray,
      height: 18,
    },
    totalReferralsValue: {
      fontSize: Styles.Fonts.f3,
      fontWeight: 'bold',
      textAlign: 'left',
      fontFamily: Styles.FontFamily.robotoRegular,
      color: Styles.tabBarTextColor,
    },
    shareViaEmailTitle: {
      fontSize: Styles.Fonts.f7,
      fontWeight: '400',
      textAlign: 'left',
      fontFamily: Styles.FontFamily.robotoRegular,
      color: Styles.tabBarTextColor,
    },
    errorLabel: {
      color: Styles.dangerColor,
      fontSize: Styles.Fonts.f8,
      alignSelf: 'flex-start',
      fontFamily: Styles.FontFamily.robotoRegular,
      marginHorizontal: Styles.Spacing.m3,
      marginTop: Styles.Spacing.m1,
    },
    orText: {
      fontSize: Styles.Fonts.f1,
      textTransform: 'uppercase',
      color: Styles.tabBarTextColor,
      fontFamily: Styles.FontFamily.robotoRegular,
      marginHorizontal: Styles.Spacing.m3,
    },
  };
}

export function getReferralTitleMsg(
  amount: string,
  transactionMinimum?: string,
): string {
  return Localized.Labels.formatString(
    Localized.Labels.referral_invite_earn_desc,
    'Connect & Pay',
    transactionMinimum,
    amount,
  ).toString();
}

export function getReferralHeaderIcon() {
  return (
    <GrpReferralRedesign
      width={78}
      height={74}
      gradColor1={Styles.Colors.Canteen.darkGreen}
      gradColor2={Styles.Colors.Canteen.lightGreen}
    />
  );
}

export function getSendInviteButton(
  checkDisabled: () => boolean,
  callback: () => void,
) {
  return (
    <View
      style={{
        marginHorizontal: Styles.Spacing.m3 + Styles.Spacing.m2,
        marginVertical: Styles.Spacing.m3 + Styles.Spacing.m2,
      }}
    >
      <RoundedAppButton
        buttonType={RoundedAppButtonType.Solid}
        onPress={callback}
        isDisabled={checkDisabled()}
        inActiveButtonViewStyle={{
          backgroundColor: Styles.Colors.PayNew.darkHuesBase04,
          width: '100%',
        }}
        inActiveTextStyle={[{fontSize: Styles.Fonts.f1}]}
        textStyle={[{fontSize: Styles.Fonts.f1}]}
        buttonViewStyle={{
          width: '100%',
        }}
        buttonContainerStyle={{
          width: screenWidth,
          alignItems: 'center',
          justifyContent: 'center',
          paddingHorizontal: Styles.Spacing.m3 + Styles.Spacing.m2,
        }}
        accessibilityLabelValue="Send Invite"
        titleText={Localized.Buttons.send_invite}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
      />
    </View>
  );
}

export default {
  getReferralStyles,
  getReferralTitleMsg,
  getReferralHeaderIcon,
  getSendInviteButton,
};
